<template>
  <div class="donga-audit">
    <admin-header></admin-header>
    <div class="audit-template admin-template">
      <admin-aside></admin-aside>
      <div class="admin-container">
        <h2 class="contents-tit">그룹 관리</h2>
        <div class="admin-manage-btn-top">
            <button type="button" class="sysadmin-default-btn" @click="showModal=true">생성</button>
        </div>
        <section class="admin-contents">
          <div class="card-body">
            <table class="card-table">
              <caption>그룹 관리</caption>
              <colgroup>
                <col style="width:30%">
                <col style="width:50%">
                <col style="width:20%">
              </colgroup>
              <tr>
                <th>그룹명</th>
                <th>비고</th>
                <th>상태</th>
              </tr>
              <tr v-for="(item, index) in this.getSysadminGroups" v-bind:key="index" @click="fnModify(item)">
                  <td>{{ item.name }}</td>
                  <td>{{ item.description }}</td>
                  <td>{{ item.statusTitle }}</td>
              </tr>
            </table>
          </div>
        </section>
        <modal v-if="showModal" @close="showModal=false">
            <h3 slot="body">
                <div class="form-modal-container">
                    <div class="form-modal">
                        <div class="input-area">
                        <label class="form-label" for="report-title">그룹명 *</label>
                        <input
                            v-model.trim="groupName"
                            class="default-input form-input"
                            type="text"
                            id="report-title"
                            placeholder="그룹명">
                        </div>
                    </div>
                    <div class="form-modal">
                        <div class="input-area">
                        <label class="form-label" for="report-description">비고</label>
                        <input
                            v-model.trim="description"
                            class="default-input form-input"
                            type="text"
                            id="report-description"
                            placeholder="비고">
                        </div>
                    </div>
                    <div class="form-modal" v-if="flag === 'U'">
                        <div class="input-area">
                            <label class="form-label" for="report-status">사용여부</label>
                            <select name="state-select" id="state-select" class="default-select" v-model="statusCode">
                                <option v-for="(type) in this.getStatuses" v-bind:key="type.title" v-bind:value="type.code">
                                {{ type.title }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="modal-btn-area">
                    <button type="button" class="modal-btn-save" @click="save()">저장</button>
                    <button type="button" class="modal-btn-cancle" @click="cancle()">닫기</button>
                </div>
            </h3>
        </modal>
      </div>
    </div>
    <admin-footer></admin-footer>
  </div>
</template>

<style lang="scss" scoped>
@import '../css/sub.scss';
@import '../css/admin.scss';
</style>

<script>
import AdminHeader from '@/components/AdminHeader'
import AdminFooter from '@/components/AdminFooter'
import AdminAside from '@/components/AdminAside'
import Modal from '@/components/AdminModal'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AdminGroup',
  components: {
    'admin-footer': AdminFooter,
    'admin-header': AdminHeader,
    'admin-aside': AdminAside,
    'modal': Modal
  },
  data () {
    return {
      showModal: false,
      groupName: '',
      description: '',
      statusTitle: '',
      statusCode: '',
      flag: 'C',
      id: ''
    }
  },
  created () {
    this.setInit({'method': 'GET'})
  },
  methods: {
    ...mapActions({
      setInit: 'apiSysadminGroups'
    }),
    fnModify (item) {
      this.id = item.id
      this.groupName = item.name
      this.description = item.description
      this.statusTitle = item.statusTitle
      this.statusCode = item.statusCode
      this.flag = 'U'
      this.showModal = true
    },
    save () {
      if (this.groupName === '') {
        alert('필수값을 입력해주세요.')
        return
      }
      if (this.flag === 'U') { // 수정일 경우
        const params = {
          'name': this.groupName,
          'description': this.description,
          'status': this.statusCode,
          'id': this.id,
          'method': 'PATCH'
        }
        console.log(params)
        this.$store.dispatch('apiSysadminGroups', params)
      } else { // 생성일 경우
        const params = {
          'name': this.groupName,
          'description': this.description,
          'method': 'POST'
        }
        this.$store.dispatch('apiSysadminGroups', params)
      }
      // this.initValues()
    },
    cancle () {
      this.initValues()
    },
    initValues () {
      this.id = ''
      this.groupName = ''
      this.description = ''
      this.statusTitle = ''
      this.statusCode = ''
      this.flag = 'C'
      this.showModal = false
    }
  },
  computed: {
    ...mapGetters(['getSysadminGroups', 'getStatuses'])
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/AdminGroup.vue